import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';

export default class PassbackAddressCMSModel implements CMSModel {
  page_title = '';
  page_subtitle = '';
  page_description = '';
  forms_header = '';
  forms_desc = '';
  copy_address_description = '';
  copy_address = '';
  copy_address_popup_title = '';
  copy_address_popup_content = '';
  house_number = '';
  street = '';
  city = '';
  postcode = '';

  map(obj: any): any {
    this.page_title = _.get(obj, 'translation[0].page_title');
    this.page_subtitle = _.get(obj, 'translation[0].page_subtitle');
    this.page_description = _.get(obj, 'translation[0].page_description');
    this.forms_header = _.get(obj, 'translation[0].forms_header');
    this.forms_desc = _.get(obj, 'translation[0].forms_desc');
    this.copy_address_description = _.get(obj, 'translation[0].copy_address_description');
    this.copy_address = _.get(obj, 'translation[0].copy_address');
    this.copy_address_popup_title = _.get(obj, 'translation[0].copy_address_popup_title');
    this.copy_address_popup_content = _.get(obj, 'translation[0].copy_address_popup_content');
    this.house_number = _.get(obj, 'translation[0].house_number', '');
    this.street = _.get(obj, 'translation[0].street', '');
    this.city = _.get(obj, 'translation[0].city', '');
    this.postcode = _.get(obj, 'translation[0].postcode', '');
  }
}
